import React, { useState, useEffect } from "react";
import { object, string, func, number } from "prop-types";

import { Card } from "../story-elements";
import LiveBlogTime from "../../atoms/live-blog-timestamp";
import FirstPublished from "../../atoms/first-published";
import CheckBox from "../../atoms/checkbox";
import StoryHeader from "../header-block";
import StorySideBar from "../story-sidebar-elements";
import KeyEvents from "../story-sidebar-elements/key-events";
import BottomStoryElements from "../story-elements/bottom-story-elements";
import { getStory } from "../../helper/api";
import ReadFullArticle from "../story-elements/read-full-article";
import { AdFree, StoryResponsiveContainer } from "../../rows/ad-free";
import LoadMore from "../../atoms/loadmore";
import translate from "../../translate";

import "./live-blog.m.css";

const AdSlot = ({ mobile, story }) => (
  <AdFree>
    <StoryResponsiveContainer desktop="storyContentDesktop" mobile={mobile} story={story} />
  </AdFree>
);

AdSlot.propTypes = {
  mobile: string,
  story: object,
};

const StoryContent = ({ index, story, displayOrder, setDisplayOrder, publisherName }) => {
  const [cardsToLoad, setcardsToLoad] = useState({ clickCount: 0, maxItems: 4 });

  useEffect(() => {
    if (cardsToLoad.clickCount) {
      window.location.hash = `#${cardsToLoad.clickCount}`;
      window.dataLayer.push({
        clickCount: `${cardsToLoad.clickCount}`,
      });
    }
  }, [cardsToLoad.clickCount]);

  if (!story.cards.length) return null;

  const [firstCard, ...cards] = story.cards;

  const dispalyOrderChange = (value) => () => setDisplayOrder(value);

  const cardsToIterate = cards.slice(0, cardsToLoad.maxItems);

  const children = cardsToIterate.map((card, index) => {
    return (
      <div className="story-cards" key={card.id} id={card.id}>
        <div styleName="timestamp">
          <a name={`live-blog-card-${card.id}`}></a>
          <LiveBlogTime card={card} />
        </div>
        <Card publisherName={publisherName} key={card.id} card={card} story={story} />
        {index === 2 && <AdSlot mobile="storyPrem2" story={story} />}
        {index === 4 && <AdSlot mobile="storyATF" story={story} />}
        {index > 5 && index % 2 === 0 && <AdSlot mobile="storyBTF" story={story} />}
      </div>
    );
  });

  const loadMoreCards = () => {
    setcardsToLoad((prevState) => {
      return {
        clickCount: prevState.clickCount + 1,
        maxItems: prevState.maxItems + 4,
      };
    });
  };

  return (
    <ReadFullArticle storyIndex={index}>
      <div>
        <Card publisherName={publisherName} key={firstCard.id} card={firstCard} story={story} />
        <div styleName="select-order">
          <CheckBox isChecked={displayOrder === "new"} text="Newest First" onChange={dispalyOrderChange("new")} />
          <CheckBox isChecked={displayOrder === "old"} text="Oldest First" onChange={dispalyOrderChange("old")} />
        </div>

        <div styleName={`display-order ${displayOrder === "old" ? "reverse" : ""}`}>
          {cards.length ? children : null}
          {cardsToLoad.maxItems >= cards.length ? null : (
            <>
              <center>
                <LoadMore
                  id="read-more-live-blog"
                  onClick={loadMoreCards}
                  content={translate(publisherName, "load_more")}
                />
              </center>
              <br />
            </>
          )}
        </div>
        <FirstPublished story={story} />
      </div>
    </ReadFullArticle>
  );
};

StoryContent.propTypes = {
  story: object,
  displayOrder: string,
  setDisplayOrder: func,
  index: number,
  publisherName: string,
};

const LiveBlog = ({ story, index, publisherName }) => {
  const [displayOrder, setDisplayOrder] = useState("new");

  const [storyData, setStoryData] = useState(story);

  useEffect(() => {
    const storyUpdate = setInterval(() => {
      getStory(storyData.id).then((story) => setStoryData(story));
    }, 30000);

    return () => {
      if (storyUpdate) clearInterval(storyUpdate);
    };
  }, []);

  return (
    <div styleName="story-wrapper">
      <div>
        <StoryHeader story={storyData} isLiveBlog />
        <StoryContent
          publisherName={publisherName}
          story={storyData}
          displayOrder={displayOrder}
          setDisplayOrder={setDisplayOrder}
          index={index}
        />
        <BottomStoryElements story={storyData} index={index} />
      </div>
      <div>
        <StorySideBar index={index} story={story} />
        <KeyEvents story={storyData} displayOrder={displayOrder} />
      </div>
    </div>
  );
};

LiveBlog.propTypes = {
  story: object,
  index: number,
  publisherName: string,
};

export default LiveBlog;
